// =====================================================
// SCHEMAS: DISCOUNT
// Description: Schémas de validation Zod pour les réductions
// =====================================================

import { z } from 'zod';

export const createDiscountSchema = z.object({
  name: z.string().min(1, 'Le nom est requis').max(200, 'Le nom est trop long'),
  amount: z.number().positive('Le montant doit être positif'),
  status: z.enum(['Active', 'Inactive']),
});

export const updateDiscountSchema = z.object({
  name: z.string().min(1, 'Le nom est requis').max(200, 'Le nom est trop long').optional(),
  amount: z.number().positive('Le montant doit être positif').optional(),
  status: z.enum(['Active', 'Inactive']).optional(),
});

export type CreateDiscountInput = z.infer<typeof createDiscountSchema>;
export type UpdateDiscountInput = z.infer<typeof updateDiscountSchema>;
